import { ApiFactoryClassType } from './factory';
import { FormValues } from '../components/form/types';
import { PaginationType, RemoveResponse } from './types';

const calendar = (factory: ApiFactoryClassType) => ({
    createCalendarEvent: async (calendarEventObj: FormValues): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL('/api/event/create', factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(calendarEventObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    editCalendarEvent: async (
        calendarEventObj: FormValues,
        id: string,
    ): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/event/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(calendarEventObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    listCalendarEvents: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: string
    ): Promise<PaginationType | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const url = new URL(`/api/event/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`, factory.getApiHost());
            const response = await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getCalendarEntryById: async (id: string): Promise<any | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/event/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    batchDeleteCalendarEvents: async (ids: string[]): Promise<RemoveResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/event/delete`, factory.getApiHost()),
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    body: JSON.stringify(ids),
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    }
});

export default calendar;
